import fetch from 'isomorphic-fetch';
import createAction from './createAction';
import UISettings from '../../utils/UISettings';
// import { normalizeProductAttachments } from '../../components/react/ProductAttachments/services';
// import * as UISettings from '../../utils/UISettings';

// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('../../../node_modules/icepick/icepick.min');

// 1. Initial state
const initialState = icepick.freeze({
  product: null,
  basket: {
    id: '1',
    products: {},
    error: false,
    updating: false
  },
  allowRedirect: false,
  addDynamicBundle: false,
  carePlans: {
    isLoading: true,
    data: null,
    error: null
  }
});

// 2. Actions
const GET_CAREPLAN_BENEFITS_START = 'productPage/GET_CAREPLAN_BENEFITS_START';
const GET_CAREPLAN_BENEFITS_SUCCESS = 'productPage/GET_CAREPLAN_BENEFITS_SUCCESS';
const GET_CAREPLAN_BENEFITS_ERROR = 'productPage/GET_CAREPLAN_BENEFITS_ERROR';

const SET_PRODUCT = 'productPage/SET_PRODUCT';
const SET_BASKET_ID = 'productPage/SET_BASKET_ID';

const GET_BASKET_REQUEST = 'productPage/basket/GET_BASKET';
const GET_BASKET_SUCCESS = 'productPage/basket/GET_BASKET_SUCCESS';
const GET_BASKET_FAILURE = 'productPage/basket/GET_BASKET_FAILURE';

const ADD_PRODUCT_REQUEST = 'productPage/basket/ADD_PRODUCT_REQUEST';
const ADD_PRODUCT_SUCCESS = 'productPage/basket/ADD_PRODUCT_SUCCESS';
const ADD_PRODUCT_FAILURE = 'productPage/basket/ADD_PRODUCT_FAILURE';

const DELETE_PRODUCT_REQUEST = 'productPage/basket/DELETE_PRODUCT_REQUEST';
const DELETE_PRODUCT_SUCCESS = 'productPage/basket/DELETE_PRODUCT_SUCCESS';
const DELETE_PRODUCT_FAILURE = 'productPage/basket/DELETE_PRODUCT_FAILURE';

const ALLOW_REDIRECT = 'productPage/ALLOW_REDIRECT';
const DISALLOW_REDIRECT = 'productPage/DISALLOW_REDIRECT';

const ADD_DYNAMIC_BUNDLE = 'basket/ADD_DYNAMIC_BUNDLE';

const EMPTY_ATTACHMENT_PRODUCTS = 'productPage/attachmentProducts/EMPTY_ATTACHMENT_PRODUCTS';

// 3. Action creators
const carePlanBenefitsStart = () => createAction(GET_CAREPLAN_BENEFITS_START);
const carePlanBenefitsSuccess = (result) => createAction(GET_CAREPLAN_BENEFITS_SUCCESS)(result);
const carePlanBenefitsError = (error) => createAction(GET_CAREPLAN_BENEFITS_ERROR)(error);

const storeApiRequest = () => {
  const storeApiUrl = UISettings.get('component.carePlan.benefitsLink');
  return fetch(storeApiUrl);
};

export const getCarePlanBenefits = () => (dispatch) => {
  dispatch(carePlanBenefitsStart());
  return storeApiRequest()
    .then((response) => response.json())
    .then((result) => dispatch(carePlanBenefitsSuccess(result)))
    .catch((error) => dispatch(carePlanBenefitsError(error)));
};

const addProductRequest = createAction(ADD_PRODUCT_REQUEST);
const addProductSuccess = createAction(ADD_PRODUCT_SUCCESS);
const addProductFailure = createAction(ADD_PRODUCT_FAILURE);

const deleteProductRequest = createAction(DELETE_PRODUCT_REQUEST);
const deleteProductSuccess = createAction(DELETE_PRODUCT_SUCCESS);
const deleteProductFailure = createAction(DELETE_PRODUCT_FAILURE);

const addDynamicBundle = createAction(ADD_DYNAMIC_BUNDLE);

export const setProduct = (product) => createAction(SET_PRODUCT)(product);
export const setBasketId = (basketId) => createAction(SET_BASKET_ID)(basketId);
export const emptyAttachmentProducts = () => createAction(EMPTY_ATTACHMENT_PRODUCTS)([]);

const allowRedirect = () => createAction(ALLOW_REDIRECT)();
export const disallowRedirect = () => createAction(DISALLOW_REDIRECT)();

const getHost = () => document.location.origin;

export const addProductToBasket = (
  basketId, mainProductId, accessoryIds = []
) => (dispatch) => {
  if (mainProductId && basketId) {
    const isDynamicBundle = accessoryIds.length > 0;
    const bundleId = isDynamicBundle ? `DP${mainProductId}` : null;
    const productId = isDynamicBundle ? accessoryIds[0] : mainProductId;
    if (isDynamicBundle) {
      dispatch(addProductRequest(productId));
      deleteProductFromBasketByFoSite(mainProductId, basketId, () => {
        dispatch(addDynamicBundle());
      })(dispatch);
    } else {
      dispatch(addProductRequest(productId));

      addProductToBasketByFoSite(productId, basketId, bundleId, accessoryIds)(dispatch);
    }
  } else {

    throwAddProductError(
      dispatch,
      `Expected productId or basketId has a string, ${mainProductId} given.`,
      mainProductId
    );
  }
};

export const deleteProductFromBasket = (basketId, productId) => (dispatch) => {
  if (productId && basketId) {
    dispatch(deleteProductRequest(productId));

    deleteProductFromBasketByFoSite(productId, basketId)(dispatch);
  } else {
    throwDeleteProductError(
      dispatch,
      `Expected productId or basketId has a string, ${productId} given.`,
      productId
    );
  }
};

function throwAddProductError(dispatch, error, productId) {
  // eslint-disable-next-line no-console
  console.error(error);
  dispatch(addProductFailure(productId));
}

function throwDeleteProductError(dispatch, error, productId) {
  // eslint-disable-next-line no-console
  console.error(error);
  dispatch(deleteProductFailure(productId));
}

function getCountItemsInBasket() {
  const basketFetchOptions = {
    method: 'GET',
    credentials: 'same-origin'
  };

  return fetch(`${getHost()}/gb/uk/cart/ajax.html`, basketFetchOptions)
    .then((response) => response.json())
    .then((body) => body.content)
    .then((html) => html.match('>([0-9]*)</span>')[1])
    .then((count) => Number(count));
}

function addProductToBasketByFoSite(productId, basketId, bundleId = null, accessoryIds = []) {
  return function dispatchAction(dispatch) {
    const url = `${document.location.href}`;
    const isDynamicBundle = accessoryIds.length > 0;

    const formData = new FormData();
    formData.append('subaction', 'cart');
    formData.append('sFUPID', bundleId ? bundleId : productId);
    formData.append('iQuantity', '1');
    formData.append('action', 'addProduct');

    if (isDynamicBundle) {
      accessoryIds.forEach((itemId) => {
        formData.append('addonProductsIds[]', itemId);
      });
    }

    fetchToFoSite(
      url, formData, productId, basketId, () => {
        if (isDynamicBundle) {
          deleteProductFromBasketByFoSite(productId, basketId, () => {
            getCountItemsInBasket().then((count) => {
              dispatch(addProductSuccess({
                productId: productId,
                basket: {
                  id: basketId,
                  totalProductsQuantity: count
                }
              }));
              dispatch(allowRedirect());
            })
              .catch(
                (error) => {
                  throwAddProductError(
                    dispatch,
                    error,
                    productId
                  );
                  dispatch(allowRedirect());
                }
              );
          })(dispatch);
        } else {
          dispatch(allowRedirect());
        }
      }
    )(dispatch, addProductSuccess, throwAddProductError);
  };
}

function deleteProductFromBasketByFoSite(productId, basketId, onFinished = null) {
  return function dispatchAction(dispatch) {
    const url = `${document.location.origin}/gbuk/o/initorder/basket-confirmation.html`;

    const formData = new FormData();
    formData.append('subaction', 'basketConfirmation');
    formData.append('sFormName', 'basketConfirmation');
    formData.append(`remove[${productId}]`, 'x Remove');

    fetchToFoSite(
      url, formData, productId, basketId, onFinished
    )(dispatch, deleteProductSuccess, throwDeleteProductError);
  };
}

function fetchToFoSite(url, formData, productId, basketId, onFinished = null) {
  return function dispatchAction(dispatch, action, throwError) {

    fetch(url, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
      .then((response) => {
        if (response.status === 200) {
          getCountItemsInBasket().then((count) => {
            dispatch(action({
              productId: productId,
              basket: {
                id: basketId,
                totalProductsQuantity: count
              }
            }));
            if (onFinished) {
              onFinished();
            } else {
              dispatch(allowRedirect());
            }
          })
            .catch(
              (error) => {
                throwError(
                  dispatch,
                  error,
                  productId
                );
                if (onFinished) {
                  onFinished(error);
                } else {
                  dispatch(allowRedirect());
                }
              }
            );
        }
      })
      .catch(
        (error) => {
          // eslint-disable-next-line no-console
          console.log('Fetch error:', error);
          if (onFinished) {
            onFinished(error);
          } else {
            dispatch(allowRedirect());
          }
        }
      );
  };
}

function getProductState(products, productId) {
  const product = products[productId];
  return product || {
    error: false,
    updating: false
  };
}

function updateProductState(productsInState, productId, productState) {
  const products = { ...productsInState };
  const product = getProductState(products, productId);
  products[productId] = {
    ...product,
    ...productState
  };

  return products;
}

// 4. Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_PRODUCT:
      return icepick.setIn(state, ['product'], action.payload);
    case SET_BASKET_ID:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        id: action.payload
      });
    case ADD_PRODUCT_REQUEST:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        products: updateProductState(
          state.basket.products,
          action.payload,
          {
            error: false,
            updating: true
          }
        ),
        error: false
      });
    case ADD_PRODUCT_SUCCESS:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        id: action.payload.basket.id,
        content: {
          ...state.basket.content,
          ...action.payload.basket
        },
        products: updateProductState(
          state.basket.products,
          action.payload.productId,
          {
            error: false,
            updating: false
          }
        )
      });
    case ADD_PRODUCT_FAILURE:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        products: action.payload
          ? updateProductState(
            state.basket.products,
            action.payload,
            {
              error: true,
              updating: false
            }
          )
          : state.products,
        error: !action.payload,
        updating: false
      });

    case DELETE_PRODUCT_REQUEST:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        products: updateProductState(
          state.basket.products,
          action.payload,
          {
            error: false,
            updating: true
          }
        ),
        error: false
      });
    case DELETE_PRODUCT_SUCCESS:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        id: action.payload.basket.id,
        content: {
          ...state.basket.content,
          ...action.payload.basket
        },
        products: updateProductState(
          state.basket.products,
          action.payload.productId,
          {
            error: false,
            updating: false
          }
        )
      });
    case DELETE_PRODUCT_FAILURE:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        products: action.payload
          ? updateProductState(
            state.basket.products,
            action.payload,
            {
              error: true,
              updating: false
            }
          )
          : state.products,
        error: !action.payload,
        updating: false
      });

    case GET_BASKET_REQUEST:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        error: false,
        updating: false
      });
    case GET_BASKET_SUCCESS:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        id: action.payload.id,
        content: action.payload
      });
    case GET_BASKET_FAILURE:
      return icepick.setIn(state, ['basket'], {
        ...state.basket,
        content: undefined
      });
    case ALLOW_REDIRECT:
      return icepick.set(state, 'allowRedirect', true);
    case DISALLOW_REDIRECT:
      return icepick.set(state, 'allowRedirect', false);

    case ADD_DYNAMIC_BUNDLE:
      return icepick.set(state, 'addDynamicBundle', true);

    case GET_CAREPLAN_BENEFITS_START:
      return icepick.setIn(state, ['carePlans', 'isLoading'], true);

    case GET_CAREPLAN_BENEFITS_SUCCESS:
      return icepick.setIn(state, ['carePlans'], {
        data: action.payload.payload, isLoading: false, error: null
      });

    case GET_CAREPLAN_BENEFITS_ERROR:
      return icepick.setIn(state, ['carePlans'], {
        data: null,
        error: action.payload,
        isLoading: false
      });
    default:
      return state;
  }
}
